// Formattor for Random Gift Picker
// Turning off key spacing due to large dataset formatting
/* eslint key-spacing: 0 */
/* eslint complexity: 0 */

var site = site || {};
var randomPrize = randomPrize || {};
var generic = generic || {};

(function ($) {
  randomPrize.GameReady = $.Deferred();
  randomPrize.offerApplied = $.Deferred();
  randomPrize.products = [];
  randomPrize.offer_array = [];
  randomPrize.number_of_prizes = '';
  randomPrize.winning_offer;
  randomPrize.winning_sku;
  randomPrize.winning_product;
  randomPrize.winning_category;
  randomPrize.offer_probability = [];
  randomPrize.offerProducts = {};
  randomPrize.cartResult = {};
  randomPrize.available_offers = {};
  randomPrize.continuePlayOnceWon = 1; // allow the game to continue once the user has one
  randomPrize.stopGameFor24HoursOnceWon = 1; // stop the game once offer added to bag
  randomPrize.skuFilter = ['INVENTORY_STATUS', 'SKU_ID', 'PRODUCT_CODE'];
  randomPrize.productFilter = ['LARGE_IMAGE'];
  randomPrize.categoryFilter = [];
  randomPrize.offerFilter = [];
  randomPrize.prizeData = {};
  randomPrize.mapping = [];

  /**
   * Convenience method to run all methods in this object
   * @param {array} prodArray - array of products
   * @intended access public
   *
   * @returns {bool} true
   */
  randomPrize.init = function () {
    randomPrize._getDom();
    randomPrize._showLoading();
    randomPrize._parseOfferAndProbability();
    $.when(randomPrize.GameReady).then(function () {
      randomPrize._setUpGame();
    });

    return true;
  };

  /*
   *
   * Set up Game
   *
   */
  randomPrize._setUpGame = function () {
    if (randomPrize.isGameValidforPlay()) {
      randomPrize._getPlay();

      return 1;
    } else {
      return 0;
    }
  };

  /*
   *
   * Validate Game
   *
   */
  randomPrize.isGameValidforPlay = function () {
    if (randomPrize._getNumberOfTriesCookie() <= randomPrize.nodes.number_of_tries) {
      if (
        randomPrize.continuePlayOnceWon ||
        (!randomPrize.continuePlayOnceWon && !randomPrize.has_won)
      ) {
        if (
          !randomPrize.stopGameFor24HoursOnceWon ||
          (randomPrize.stopGameFor24HoursOnceWon && !randomPrize._get24HourCookie())
        ) {
          return 1;
        }
      }
    }

    return 0;
  };

  /*
   *
   *Set 24 hour cookie once won
   *
   */
  randomPrize._set24HourCookie = function (won) {
    if (won) {
      var date = new Date();

      date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
      document.cookie = 'twenty_four=1;expires=' + date.toGMTString() + ';';
    }
  };

  /*
   *
   *Get 24 hour cookie
   *
   */
  randomPrize._get24HourCookie = function () {
    if (randomPrize._getCookie('twenty_four')) {
      return 1;
    }

    return 0;
  };

  /*
   *
   *Get number of tries cookie
   *
   */
  randomPrize._getNumberOfTriesCookie = function () {
    if (randomPrize._getCookie('game_tries')) {
      return randomPrize._getCookie('game_tries');
    }

    return 0;
  };

  /*
   *
   *Set number of tries cookie
   *
   */

  randomPrize._setNumberOfTriesCookie = function () {
    if (!randomPrize._getNumberOfTriesCookie()) {
      document.cookie = 'game_tries = 1';
    } else {
      var cookieCalc = parseInt(randomPrize._getNumberOfTriesCookie()) + 1;

      document.cookie = 'game_tries = ' + cookieCalc;
    }
  };

  /**
   * Set winning offer code cookie, available 24h
   */
  randomPrize.setWinningOfferCookie = function (offer_code) {
    var date = new Date();

    date.setTime(date.getTime() + (24 * 60 * 60 + 1) * 1000);
    document.cookie = 'winning_offer=' + offer_code + ';expires=' + date.toGMTString() + ';';
  };

  randomPrize.getWinningOfferCookie = function () {
    var winning_offer = randomPrize._getCookie('winning_offer');

    return winning_offer ? winning_offer : '';
  };

  randomPrize._getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  };

  /*
   * randomPrize._getDom
   * This is where we get all the DOM object
   *
   */
  randomPrize._getDom = function () {
    randomPrize.nodes = {
      win_image: $('#win-image'),
      win_description: $('#win-description'),
      win_offer_messages: $('#win-offer-messages'),
      need_help: $('#need-help-text'),
      help_overlay: $('.help-overlay'),
      game_tries: $('#game-tries-numbers span'),
      landing: $('.game-landing'),
      unavailable: $('#game-unavailable'),
      productMapping: $('#mapping').val(),
      loading: $('#loading'),
      terms_and_conditions_text: $('#terms-and-conditions-text'),
      terms_and_conditions: $('#terms-and-conditions'),
      close_btn: $('#terms-close-btn'),
      offer_codes: $('#offer_codes').val(),
      win_chance: parseInt($('#win_chance').val()) || 50,
      number_of_tries: parseInt($('#no_of_tries').val()) || 3,
      showHelpOnLoad: $('#show_help_onload').val() || 0,
      usingCustomImages: $('#popup_show_custom_images').val() || 0,
      customImageFolder: $('#popup_custom_image_folder').val() || '',
      playAgainBtn: $('#try-again-btn'),
      apply_offer_btn: $('.apply_offer'),
      errors: {
        noSearchTerm: $('ul.error_messages li.no-search-term')
      }
    };
  };

  /*
   * randomPrize._parseOfferAndProbability
   * This is where we get all the offers, set the probability (if set in Drupal) and set the winning price
   *
   */
  randomPrize._parseOfferAndProbability = function () {
    randomPrize.offer_array = $.map(randomPrize.nodes.offer_codes.split(','), $.trim);

    var params = [
      {
        offers: randomPrize.offer_array,
        get_products: 1,
        get_transaction: 0
      }
    ];

    generic.jsonrpc.fetch({
      method: 'offers.getRandomPrizeOfferData',
      params: params,
      onSuccess: function (response) {
        var responseValues = response.getValue();

        if (responseValues && responseValues.offers && Object.keys(responseValues.offers).length) {
          randomPrize.available_offers = responseValues.offers;
        }

        if (
          responseValues &&
          responseValues.transaction &&
          Object.keys(responseValues.transaction).length
        ) {
          randomPrize.cartResult = responseValues.transaction;
        }

        if (
          responseValues &&
          responseValues.offersProducts &&
          Object.keys(responseValues.offersProducts).length
        ) {
          randomPrize.offerProducts = responseValues.offersProducts;
        }

        $.each(randomPrize.available_offers, function (key, value) {
          if (value === null) {
            // check offer exists
            delete randomPrize.available_offers[key]; // remove from object
          } else {
            // check all offers are active
            if (value['timing'] !== 'active') {
              delete randomPrize.available_offers[key]; // remove from object
            }
          }
        });

        if (Object.keys(randomPrize.available_offers).length > 0) {
          $.each(randomPrize.offer_array, function (key, value) {
            var offer_and_probability = value.split(':');

            if (typeof offer_and_probability === 'object') {
              if (Object.keys(offer_and_probability).length > 1) {
                randomPrize.offer_array[key] = offer_and_probability[0];
                randomPrize.offer_probability[offer_and_probability[0]] = offer_and_probability[1];
              } else {
                randomPrize.offer_array[key] = offer_and_probability[0];
                randomPrize.offer_probability[offer_and_probability[0]] =
                  100 / Object.keys(randomPrize.available_offers).length;
              }
            } else {
              // should never hit here as offers should always be an object
              randomPrize.offer_array[key] = key;
              randomPrize.offer_probability[offer_and_probability[0]] =
                100 / Object.keys(randomPrize.available_offers).length;
            }
          });

          randomPrize._setPrize(randomPrize.offer_array, randomPrize.offer_probability);
          randomPrize._getPrize();
          // now we can do some animation stuff, play a game etc
          randomPrize.GameReady.resolve();
        } else {
          randomPrize._getUnavailableMessage($('#game-error'));
        }
      },
      onFailure: function () {
        randomPrize._getUnavailableMessage($('#game-error'));
      }
    });
  };

  /*
   * random._setPrize
   * This is where we set the prize before we even start playing the game
   *
   */
  randomPrize._setPrize = function (offers, probability) {
    var random_num = randomPrize.getRandomNumber(1, 100, true);
    var weight_sum = 0;

    for (var i = 0; i < offers.length; i++) {
      weight_sum += parseInt(probability[offers[i]]);
      weight_sum = +weight_sum;
      if (random_num <= weight_sum) {
        randomPrize.winning_offer = randomPrize.available_offers[offers[i]];
        // once we have the offer we can now get the prize if it is a sku related product
        if (typeof randomPrize.offerProducts[randomPrize.winning_offer.offer_code] === 'object') {
          // if a product type offer we should always have a sku as the backend should always return this
          if (
            randomPrize.offerProducts[randomPrize.winning_offer.offer_code].skus &&
            randomPrize.offerProducts[randomPrize.winning_offer.offer_code].skus.length
          ) {
            // backend should only return valid skus, i.e., shoppable but lets do a check just in case
            // ISSUE #01
            // Checks are functions and therefore won't return proper status so causing an infinite loop
            // if (randomPrize._checkInventoryStatus() === 1 || randomPrize._checkInventoryStatus() === 6) {
            randomPrize.winning_sku =
              randomPrize.offerProducts[randomPrize.winning_offer.offer_code].skus[
                randomPrize.getRandomNumber(
                  0,
                  randomPrize.offerProducts[randomPrize.winning_offer.offer_code].skus.length - 1,
                  true
                )
              ];
            // Set the products
            randomPrize.winning_product =
              randomPrize.offerProducts[randomPrize.winning_offer.offer_code].products[0];
            // } else {
            //   randomPrize._setPrize(randomPrize.offer_array, randomPrize.offer_probability);
            // }
          } else if (
            randomPrize.offerProducts[randomPrize.winning_offer.offer_code].products &&
            randomPrize.offerProducts[randomPrize.winning_offer.offer_code].products.length
          ) {
            // a product but should never hit here
          } else {
            // probably a category but should never hit here
          }
        }
        break;
      }
    }
  };

  /*
   * random._getPrize
   * This is where we get the prize before we even start playing the game
   *
   */
  randomPrize._getPrize = function () {
    // do we have a sku as a prize?
    if (typeof randomPrize.winning_sku === 'object') {
      $.each(randomPrize.skuFilter, function (key, value) {
        randomPrize.prizeData[value] = randomPrize.winning_sku[value]
          ? randomPrize.winning_sku[value]
          : '';
      });
      $.each(randomPrize.productFilter, function (key, value) {
        randomPrize.prizeData[value] = randomPrize.winning_product[value]
          ? randomPrize.winning_product[value]
          : '';
      });
      $.each(randomPrize.categoryFilter, function (key, value) {
        randomPrize.prizeData[value] = randomPrize.winning_category[value]
          ? randomPrize.winning_category[value]
          : '';
      });
      $.each(randomPrize.offerFilter, function (key, value) {
        randomPrize.prizeData[value] = randomPrize.winning_offer[value]
          ? randomPrize.winning_offer[value]
          : '';
      });
    }

    return randomPrize.prizeData;
  };

  /*
   * randomPrice._checkInventoryStatus
   * This is where we get the prize before we even start playing the game
   *
   */
  randomPrize._checkInventoryStatus = function () {
    return randomPrize.winning_sku['INVENTORY_STATUS'];
  };

  /*
   * randomPrice._isShoppable
   * This is where we get the prize before we even start playing the game
   *
   */
  randomPrize._isShoppable = function () {
    return randomPrize.winning_sku.isShoppable;
  };

  /**
   * Calculate if the user has won the offer yet
   * @returns {boolean} false
   */
  randomPrize._winOrNoWin = function () {
    if (Math.round(Math.random() * 100) < randomPrize.nodes.win_chance) {
      return true;
    }

    return false;
  };

  /*
   * randomPrice._getUnavailableMessage
   * Show the unavailable message
   *
   */
  randomPrize._getUnavailableMessage = function () {
    randomPrize._hideLoading();
    randomPrize.nodes.unavailable.show();
    randomPrize.nodes.landing.hide();

    if ($(window).width() < 990) {
      $('html, body').animate({ scrollTop: 0 }, 1000);
    }
  };

  /*
   * randomPrice._showLoading
   * show the loading page whlst RPC call gets data
   *
   */
  randomPrize._showLoading = function () {
    randomPrize.nodes.loading.show();
  };

  randomPrize._hideLoading = function () {
    randomPrize.nodes.loading.hide();
  };

  /*
   * randomPrice._getPlay
   * setUp the game, links etc
   *
   */
  randomPrize._getPlay = function () {
    randomPrize._hideLoading();

    // show help overlay first by default
    if (randomPrize.showHelpOnLoad) {
      randomPrize.helpOverlay();
    }

    // click to apply the offer
    randomPrize.nodes.apply_offer_btn.on('click', function (e) {
      e.preventDefault();
      $(this).addClass('loader');
      randomPrize.applyOffer();
    });

    // click need help to display help overlay
    randomPrize.nodes.need_help.on('click', function (e) {
      randomPrize.helpOverlay();
      e.stopPropagation();
    });

    // click close btn to close T&Cs
    randomPrize.nodes.close_btn.on('click', function () {
      if ($(window).width() > 764) {
        randomPrize.nodes.terms_and_conditions.hide();
      } else {
        randomPrize.nodes.terms_and_conditions.slideUp();
      }
    });

    // click anywhere to close the help overlay & desktop terms and conditions
    $(document).on('click', function () {
      if (randomPrize.nodes.help_overlay.is(':visible')) {
        randomPrize.nodes.game_tries.removeClass('overlay');
      }
      if (randomPrize.nodes.terms_and_conditions.is(':visible')) {
        if ($(window).width() > 764) {
          randomPrize.nodes.terms_and_conditions.hide();
        }
      }
    });

    // click terms and conditions text to display terms and conditions
    randomPrize.nodes.terms_and_conditions_text.on('click', function (e) {
      if ($(window).width() > 764) {
        randomPrize.nodes.terms_and_conditions.show();
        e.stopPropagation();
        // stop game being played
        randomPrize.drop_enabled = false;
      } else {
        randomPrize.nodes.terms_and_conditions.slideToggle();
        // slide down to div
        $('html,body').animate({
          scrollTop: randomPrize.nodes.terms_and_conditions.offset().top
        });
      }
    });
  };

  // function for applying the offer
  randomPrize.applyOffer = function () {
    var winningOfferInfo = randomPrize._getWinningOffer();

    if (!winningOfferInfo.valid) {
      console.log('No valid Offer', winningOfferInfo.error);

      return;
    }
    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: [
        {
          offer_code: winningOfferInfo.winning_offer.offer_code,
          do_not_defer_messages: 1
        }
      ],
      onSuccess: function (jsonRpcResponse) {
        var response = jsonRpcResponse.getValue();

        if (!response || !response.inCart) {
          console.log('Cannot apply offer');
        } else {
          console.log('Offer successfuly applied!');
        }
      },
      onFailure: function () {
        console.log('Cannot apply offer');
      },
      onBoth: function () {
        randomPrize.offerApplied.resolve();
      }
    });
  };

  //   function to show the help overlay
  randomPrize.helpOverlay = function () {
    // do not show if user has played + won
    if (!randomPrize.nodes.win_msg.is(':visible')) {
      randomPrize.nodes.win_msg.removeClass('pointer');
      randomPrize.nodes.help_overlay.show();
      randomPrize.nodes.game_tries.addClass('overlay');

      // stop game from being played whilst instructions are showing
      randomPrize.drop_enabled = false;
    }
  };

  // function for returning a random number
  randomPrize.getRandomNumber = function (numberStart, numberRange) {
    return Math.floor(Math.random() * numberRange + numberStart);
  };

  /**
   * Returns a JSON Object with the Winning Information
   *
   * @returns {Object} winInfo - Winning information in a Object Form
   */
  randomPrize._getWinningOffer = function () {
    // Check the offer we are showing, what is it?
    var offerCode = 'winning_offer' in randomPrize ? randomPrize.winning_offer.offer_code : '';
    var offerCodeCookie = randomPrize.getWinningOfferCookie();

    if (offerCodeCookie && offerCodeCookie != 'none') {
      offerCode = offerCodeCookie;
    }

    var offer =
      offerCode in randomPrize.available_offers ? randomPrize.available_offers[offerCode] : false;

    // There is no offer to return to the user
    if (!offer) {
      return {
        valid: false,
        error: 'no_offer'
      };
    }

    // user has already won something - display their prize
    if ($.inArray(offerCode, randomPrize.cartResult.offerCodes) >= 0) {
      if (randomPrize.cartResult.order && randomPrize.cartResult.order.samples) {
        // do something here
        return {
          valid: false,
          error: 'prize_already_won'
        };
      }
    }

    // Is this a SKU Offer
    var isSkuOffer = false;
    var skus = [];

    for (var i = 0; i < offer.benefits.length; i++) {
      if (offer.benefits[i].class === 'Skus') {
        isSkuOffer = true;
        for (var l = 0; l < offer.benefits[i].skus; l++) {
          skus.push(offer.benefits[i].skus[l]);
        }
      }
    }

    // Does the offer have a SKU?
    // If it does lets grab a product
    // Pick the first match for the product
    var winningProduct = false;

    if (isSkuOffer && randomPrize.nodes.usingCustomImages === '0') {
      // Grab the default product used by the offer
      var prodID = randomPrize.offerProducts.skus[offerCode][0].PRODUCT_ID;

      winningProduct = randomPrize.offerProducts.products[prodID];
    }

    var winningConfirmMessage = String(offer.confirm_message).replace(
      '::skuname::',
      winningProduct ? winningProduct.PROD_RGN_NAME : ''
    );

    // Return the Offer Object
    return {
      // Is the offer Valid or not
      valid: true,
      // Add the winning offer object
      winning_offer: offer,
      // Winning title,
      title: '',
      // Description for the win message
      description: offer.description,
      // Confirm message
      confirmMessage: winningConfirmMessage,
      // The image assosiated with this winning offer
      image: winningProduct
        ? winningProduct.LARGE_IMAGE
        : randomPrize.nodes.customImageFolder + offer.image,
      // Does the user have the ability to play again
      playAgain: parseInt(randomPrize._getNumberOfTriesCookie()) < randomPrize.nodes.number_of_tries
      //
    };
  };
})(jQuery);
